<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1"><a id="page_i"></a><a id="page_ii"></a>Also by Frances Hardinge<br/><em>Cuckoo Song<br/>The Lie Tree<br/>A Face Like Glass<br/>Verdigris Deep<br/>Fly By Night<br/>Fly Trap</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?58b14940